import { Component, OnInit, Input, ViewChild } from '@angular/core';

import { ConfirmationService, MenuItem } from 'primeng/api';
import { MessageService } from 'primeng/api';

// Export
import * as FileSaver from 'file-saver';
import { ExportService } from 'src/app/shared/services/export.service';

// Model
import { Table } from 'primeng/table';
import { TankCrudService } from 'src/app/shared/services/tank-crud.service';
import { Tank } from 'src/app/shared/interfaces/tank';
import { Wine } from 'src/app/shared/interfaces/wine';
import { WineCrudService } from 'src/app/shared/services/wine-crud.service';

@Component({
  selector: 'app-tanks',
  templateUrl: './tanks.component.html',
  styleUrls: ['./tanks.component.scss']
})
export class TanksComponent implements OnInit {

  tanks: Tank[];
  tank: Tank;
  selectedTanks: Tank[] = [];

  tankDialog: boolean = false;

  submitted: boolean = false;

  wines: Wine[];
  winesMap : Map<string,Wine>;

  // column management
  cols: any[] = [];
  _selectedColumns: any[] = [];

  // export
  @ViewChild('dt', {static: true}) dt : any;
  exportColumns: any[] = [];

  // ui beadcrumb
  breadcrumbs: MenuItem[];
  homeBreadcrumb: MenuItem = {} as MenuItem;

  hideWhenNoPallet: boolean = false;
  noData: boolean = false;
  preLoader: boolean = true;

  separatorExp: string = "[,| ]";

  constructor(
    private tankService : TankCrudService,
    private wineService : WineCrudService,
    private confirmationService: ConfirmationService,
    private messageService: MessageService,
    private exportService: ExportService
  ) { 
    // ui breadcrumbs
    this.breadcrumbs = [
      {label: 'Settings'},
      {label: 'Tanks'}
    ];

    this.tanks = [];
    this.tank = { } as Tank ;

    this.wines = [];
    this.winesMap = new Map<string,Wine>();
  }

  ngOnInit(): void {

    this.isFilter = false;
    
    this.dataState();
    let s = this.tankService.getList(); 
    s.snapshotChanges().subscribe(data => {
      this.tanks = [];
      data.forEach(item => {
        let jsonItem : { '$key': string | null } = item.payload.toJSON() as { '$key': string | null } ; 
        if (jsonItem) {
          if (jsonItem) {
            jsonItem['$key'] = item.key;
          }
          let l : Tank = jsonItem as Tank;
          if (l.tags) {
            l.tags = Object.values(l.tags);
          }
          this.tanks.push(l);
        }
      })
    });

    let wi = this.wineService.getList(); 
    wi.snapshotChanges().subscribe(data => {
      this.wines = [];
      data.forEach(item => {
        let jsonItem : { '$key': string | null } = item.payload.toJSON() as { '$key': string | null } ; 
        if (jsonItem) {
          if (jsonItem) {
            jsonItem['$key'] = item.key;
          }
          let l : Wine = jsonItem as Wine;
          if (l.tags) {
            l.tags = Object.values(l.tags);
          }
          if ( l.isEnabled ) {
            this.wines.push(l);
          };
          this.winesMap.set( l.$key , l);
        }
      });
      this.wines = this.wines.sort((a, b) => ( (a.name || 0) < (b.name || 1) ) ? -1 : 1);
     
    });

    // column management
    this.cols = [
      { field: 'name', header: 'Name' },
      { field: 'qrcode', header: 'QRCode' },
      { field: 'volume', header: 'Volume' },
      { field: 'wineName', header: 'Wine' },
      { field: 'quantity', header: 'Quantity' },
      { field: 'description', header: 'Description' },
      { field: 'tags', header: 'Tags' },
      { field: 'isEnabled', header: 'Enabled' },
      { field: 'actions', header: 'Actions' } 
    ];

    // column that we shoa at the beginning
    this._selectedColumns = this.cols;
    //this._selectedColumns = this._selectedColumns.filter( item => item.field !== 'qrcode');
    this._selectedColumns = this._selectedColumns.filter( item => item.field !== 'description');
   // this._selectedColumns = this._selectedColumns.filter( item => item.field !== 'isEnabled');

    // Exports
   // this.exportColumns = this.cols.map(col => ( {title: col.header, dataKey: col.field} ) );
   // For the PDF 
   this.exportColumns = this.cols.map(col => {
      if (col.field === 'position' || col.field === 'rank')  
        return {title: col.header, dataKey: 'position'};
      if (col.field !== 'actions')  
        return {title: col.header, dataKey: col.field};
      return {};
    } );
  }

  dataState() {     
    this.tankService.getList().valueChanges().subscribe(data => {
      this.preLoader = false;
      if(data.length <= 0){
        this.hideWhenNoPallet = false;
        this.noData = true;
      } else {
        this.hideWhenNoPallet = true;
        this.noData = false;
      }
    })
  }

  includesCol(val: string) : boolean{
    let c = this._selectedColumns.find(c => c.field === val);
    return c;
  }

  // Column management
  @Input() get selectedColumns(): any[] {
    // console.log('selected columns', this._selectedColumns);
    return this._selectedColumns;
  }
  set selectedColumns(val: any[]) {
    //restore original order
    // console.log('before selected columns', this._selectedColumns);
    // console.log('before cols', this._selectedColumns);
    this._selectedColumns = this.cols.filter(col => val.includes(col));
    // console.log('after selected columns', this._selectedColumns);
  }

  // Export management
  exportPdf() {
    import("jspdf").then(jsPDF => {
        import("jspdf-autotable").then(x => {
            const doc = new jsPDF.default('l','pt');
            // @ts-ignore
            doc.autoTable(this.exportColumns, this.tanks);
            doc.save('tanks.pdf');
        })
    })
  }

  exportExcel() {
    import("xlsx").then(xlsx => {
        const worksheet = xlsx.utils.json_to_sheet(this.tanks);
        const workbook = { Sheets: { 'data': worksheet }, SheetNames: ['data'] };
        const excelBuffer: any = xlsx.write(workbook, { bookType: 'xlsx', type: 'array' });
        this.saveAsExcelFile(excelBuffer, "tanks");
    });
  }

  exportDTCSV() {
   // console.log('export csv');
    this.dt.exportCSV();
  }

  exportToCsv(): void {
    let exportCols : string[] = [];
    this.selectedColumns.forEach( sc => 
      { exportCols.push(sc.field);
        // console.log('SAVEC CSV COL F ',sc.field);
        // console.log('SAVEC CSV COL ',sc);
      });
      exportCols.push('position');
      // console.log('SAVEC CSV SELECTED LOCATIONS ', this.selectedTanks);
      // console.log('SAVEC CSV LOCATIONS ', this.tanks);
      // console.log('SAVEC CSV EXPORT COL ', exportCols);
      this.exportService.exportToCsv(this.selectedTanks, 'tanks', exportCols);
   // this.exportService.exportToCsv(this.tanks, 'tanks', ['$key', 'name', 'description', 'tags', 'isEnabled', 'actions']);
  }

  saveAsExcelFile(buffer: any, fileName: string): void {
    let EXCEL_TYPE = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
    let EXCEL_EXTENSION = '.xlsx';
    const data: Blob = new Blob([buffer], {
        type: EXCEL_TYPE
    });
    FileSaver.saveAs(data, fileName + '_' + new Date().getTime() + EXCEL_EXTENSION);
  }

  // CRUD management
  openNew() {
    this.tank = {} as Tank;
    this.submitted = false;
    this.tankDialog = true;
  }

  deleteSelectedTanks() {
    this.confirmationService.confirm({
        message: 'Are you sure you want to delete the selected tanks?',
        header: 'Confirm',
        icon: 'pi pi-exclamation-triangle',
        accept: () => {
            this.tanks = this.tanks.filter(val => !this.selectedTanks.includes(val));
            
            this.selectedTanks.forEach( tank => this.tankService.delete(tank.$key));
            this.selectedTanks = [];
            this.messageService.add({severity:'success', summary: 'Successful', detail: 'Tankss Deleted', life: 3000});
        }
    });
  }

  editTank(tank: Tank) {
    this.tank = {...tank};
    this.tankDialog = true;
  }

  deleteTank(tank: Tank) {
    this.confirmationService.confirm({
        message: 'Are you sure you want to delete ' + tank.name + '?',
        header: 'Confirm',
        icon: 'pi pi-exclamation-triangle',
        accept: () => {
            this.tanks = this.tanks.filter(val => val.$key !== tank.$key);
            this.tank = {} as Tank;
            this.tankService.delete(tank.$key);
            this.messageService.add({severity:'success', summary: 'Successful', detail: 'Tank Deleted', life: 3000});
        }
    });
  }

  hideDialog() {
    this.tankDialog = false;
    this.submitted = false;
  }

  saveTank() {
    this.submitted = true;

    if ( this.tank.name.trim() ) {
      this.tank.isEnabled = true;

      if (this.tank.$key) {
          this.tanks[this.findIndexById(this.tank.$key)] = this.tank;                
          this.messageService.add({severity:'success', summary: 'Successful', detail: 'Tank Updated', life: 3000});
          this.tankService.update(this.tank);
        } else {
          this.tank.position = this.tanks.length;
          this.tankService.add(this.tank);
      }
      this.messageService.add({severity:'success', summary: 'Successful', detail: 'Tank Created', life: 3000});
      this.tanks = [...this.tanks];
    }

    this.tankDialog = false;
    this.tank = { } as Tank;
  }

  findIndexById(id: string): number {
    let index = -1;
    for (let i = 0; i < this.tanks.length; i++) {
        if (this.tanks[i].$key === id) {
            index = i;
            break;
        }
    } 
    return index;
  }

  filter( dt : Table, event : {target: any} ) {
    dt.filterGlobal( (event.target as HTMLInputElement).value, 'contains')
  }

  completeTank(tank : Tank) {
    //console.log("SAVE", tank);
    this.tankService.update(tank);
  }

  completePosition(tank : Tank) {
   // console.log("SAVE", tank);
  //  this.tankService.updateTank(tank);


    if ( this.newPosition > -1 ) {
        tank.position = this.newPosition;
        tank = this.checkPositionLimits(tank);
        this.reorderElements(tank);
        //this.updateDB(tank);
        this.newPosition = -1;
        this.previousPosition = -1;
        return;
      }
  }


  @ViewChild('dt') tableElement: any; // already dt above
  isReordering : boolean = false;
  isAscReordering : boolean = false;
  isFilter : boolean = false;

  // Reorder
  reorder(event: any) {
    //console.log('Reorder event', event);
    // console.log('Before', this.tanks);
    // const myClonedArray = [];
    // this.tanks.forEach(val => myClonedArray.push(Object.assign({}, val)));
    // console.log('Before2', myClonedArray);
    if (event.dragIndex === event.dropIndex ) {
      return;
    }
    const startIndex = this.isAscReordering? event.dragIndex : this.tanks.length - 1 - event.dragIndex;
    const endIndex   = this.isAscReordering? event.dropIndex : this.tanks.length - 1 - event.dropIndex;
    const tankToMove = this.tanks[startIndex];
    
    
    // console.log('StartIndex', startIndex);
    // console.log('EndIndex', endIndex);

    if (startIndex < endIndex) {
      for(let index = startIndex; index < endIndex; index++) {
        this.tanks[index] = this.tanks[index+1];
        this.tanks[index].position = index;
        this.tankService.update(this.tanks[index]);
      }     
    } else {
      for(let index = startIndex; index > endIndex; index--) {
        this.tanks[index] = this.tanks[index-1];
        this.tanks[index].position = index;
        this.tankService.update(this.tanks[index]);
      }
    } 
    this.tanks[endIndex] = tankToMove;
    this.tanks[endIndex].position = endIndex;
    this.tankService.update(this.tanks[endIndex]);
  }

  // onFieldEdit(tank: Spray, fieldName: string): void {
  //   //console.log(this.tanks);
  //   console.log("Edit Init Event Called");
  //   console.log('Field name :'+fieldName);
  //   console.log('Field value :' + tank[fieldName]);
  //   if (fieldName === 'position') {
  //     if ( this.newPosition ) {
  //       tank.position = this.newPosition;
  //       tank = this.checkPositionLimits(tank);
  //       this.reorderElements(tank);
  //       //this.updateDB(tank);
  //       this.newPosition = undefined;
  //       this.previousPosition = undefined;
  //       return;
  //     }
      
  //   } else {
  //     this.updateDB(tank);
  //   }
  // }


  ngAfterViewInit() {
    this.dt.onSort.subscribe((data: { field: string; order: number; }) => {
        if (data.field && data.field === "position") {
          this.isReordering = true;
          this.isAscReordering = (data.order == 1);
          // console.log("ASC", this.isAscReordering);
          // console.log("data.order", data.order);
        } else {
          this.isReordering = false;
        }
    });
    this.dt.onFilter.subscribe( (data: {
      filteredValue: {
        [x: string]: any; field: string; order: number; 
}; field: string; order: number; 
}) => {
      if (data && data.filteredValue) {
        this.isFilter = !(this.tanks.length === data.filteredValue['length']);
      } else {
        this.isFilter = false;
      }
  });
  
}


  previousPosition : number = -1;
  newPosition : number = -1;

  modelChangeFn(event: number, tank: Tank) {
    // console.log("event" +event);
    if (tank.position != null && tank.position > -1) {
      this.previousPosition = tank.position;
      this.newPosition = event;
    }
   
    // console.log("previous" +this.previousPosition);
    // console.log("new" +this.newPosition);
  }

  checkPositionLimits(tank: Tank) {
    console.log('check ',tank.position + ' ' + this.tanks.length);
    if (!tank.position) {
     // console.log('check 1');
      return this.tank;
    }
    if (tank.position < 0) {
      tank.position = 0;
      // console.log('check 2');
      return tank;
    }
    if (tank.position > this.tanks.length) {
      tank.position = this.tanks.length - 1;
    //  console.log('check 3', tank.position);
      return tank;
    }
   // console.log('check 4');
    return tank;
  }

  async reorderElements(tank: Tank) {
    this.newPosition = this.newPosition  > this.tanks.length ? this.tanks.length - 1 : this.newPosition;
    this.newPosition = this.newPosition  < 0 ? 0 : this.newPosition;
    if (this.previousPosition === tank.position ) {
      return;
    }
    // console.log('Previous position: '+ this.previousPosition);
    // console.log('New position: '+ this.newPosition);
    const startIndex = this.previousPosition;
    const endIndex   = this.newPosition;
    const tankToMove = this.tanks[startIndex];
   // console.log('Item to move: ', this.tanks[startIndex]);
    if (startIndex < endIndex) {
      for(let index = startIndex; index < endIndex; index++) {

        console.log('LOC', this.tanks);
        console.log('Item to +1: ', this.tanks[index+1]);

        this.tanks[index] = this.tanks[index+1];
        this.tanks[index].position = index;
        // console.log('Move: ', this.tanks[index+1]);
        // console.log('Move pos: ', this.tanks[index].position);
        //await this.updateDB(this.tanks[index]);
        this.tankService.update(this.tanks[index]);
     //   console.log('Update DB: ', this.tanks[index]);
      }     
    } else {
      for(let index = startIndex; index > endIndex; index--) {
        this.tanks[index] = this.tanks[index-1];
        this.tanks[index].position = index;
        this.tankService.update(this.tanks[index]);
      }
    } 
    this.tanks[endIndex] = tankToMove;
    this.tanks[endIndex].position = endIndex;
    this.previousPosition = -1;
    this.newPosition = -1;
    this.tankService.update(this.tanks[endIndex]);
    
    // const myClonedArray = [];
    // this.tanks.forEach(val => myClonedArray.push(Object.assign({}, val)));
    // this.tanks = myClonedArray;
   // this.getAllRecords();
  }

  onChangeWine(tank: Tank, tankWineKey: string, event: any): boolean {

    // console.log('barrel event', event);
    // console.log('be ', event);

    const newKey = event.value;
    const previousKey = tankWineKey;
    // console.log('new key wanted',  newBarrelKey);
    // console.log('before key ', previousBarrelKey);

    // Si il n'y en avait pas avant et ni maintenant, riemn a faire
    if (!previousKey && !newKey) {
      return true;
    }

    // Si le barril est le meme rien a faire
    if (previousKey && newKey && previousKey == newKey) {
      return true;
    }


    // Sil il n'y avait pas de barril avant et maintenant oui
    if (!previousKey && newKey) {

      const newWine = this.winesMap.get(newKey) || {} as Wine;
      const newWineName = newWine.name;
        
      tank.wineKey = newKey;
      tank.wineName = newWineName;
      this.tankService.update(tank);
      return true;

    }

    if (previousKey && !newKey) {
      tank.wineKey = '';
      tank.wineName = '';
      this.tankService.update(tank);
      return true;
    }

    const newWine = this.winesMap.get(newKey) || {} as Wine;
    const newWineName = newWine.name;
        
    tank.wineKey = newKey;
    tank.wineName = newWineName;
    this.tankService.update(tank);
    return true;
  }
}